import {useDisclosure} from '@chakra-ui/react';
import {useCreateCard, useGetCards, useRemoveCard, useSetMainCard} from 'api/queries/useCards';
import {CardsModal} from 'components/shared/CardsModal';
import React, {FC, PropsWithChildren, useEffect, useState} from 'react';
import {MaibCardItem} from 'types';

import {CardPaymentContext} from './contexts/CardPaymentContext';

// Re-export the hook for backward compatibility
export {useCardPayment} from './contexts/CardPaymentContext';

export const CardPaymentProvider: FC<PropsWithChildren> = ({children}) => {
  const [selectedCard, setSelectedCard] = useState<MaibCardItem | undefined>(undefined);
  const {onOpen: onOpenCardsModal, isOpen: isOpenCardsModal, onClose: onCloseCardsModal} = useDisclosure();

  const cardQuery = useGetCards();
  const mutationCreateCard = useCreateCard();
  const removeCardMutation = useRemoveCard();
  const setMainCardMutation = useSetMainCard();

  const onChangeCard = (card?: MaibCardItem) => {
    if (!card) return setSelectedCard(undefined);
    // new card
    if (card.id === 0) {
      setSelectedCard(card);
      return onCloseCardsModal();
    }

    setSelectedCard(card);
    setMainCardMutation.mutate(card.id);
    onCloseCardsModal();
  };
  const onRemoveCard = (id: number) => {
    removeCardMutation.mutate(id);
    onCloseCardsModal();
  };
  const onAddNewCard = () => {
    mutationCreateCard.mutate();
  };

  const cards = cardQuery.data;
  useEffect(() => {
    if (cards && cards?.length) {
      for (let index = 0; index < cards.length; index++) {
        const item = cards[index];
        if (item.is_main) {
          setSelectedCard(item);
          break;
        }
      }
    } else {
      setSelectedCard(undefined);
    }
  }, [cards]);

  return (
    <CardPaymentContext.Provider
      value={{cardQuery, selectedCard, onOpenCardsModal, onRemoveCard, onChangeCard, onAddNewCard}}
    >
      {children}

      <CardsModal isOpen={isOpenCardsModal} onClose={onCloseCardsModal} />
    </CardPaymentContext.Provider>
  );
};
